<template>
    <b-card no-body>
        <b-tabs>
            <b-tab title="Bens de Consumo" active>
                <b-card-body>
                    <b-card bg-variant="light">
                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFinderPageAlmoxarifado id="finderAlmoxarifadoToConsumo"
                                    @onselect="handleSelectAlmoxarifado" v-model="form.almoxarifado"
                                    :prefix="prefix + title + ' > '" />
                            </b-col>
                            <b-col>
                                <LgFinderPageProduto id="finderProduto" @onselect="handleSelectProduto"
                                    v-model="form.produto" :prefix="prefix + title + ' > '" />
                            </b-col>
                            <b-col class="d-flex align-items-center justify-content-end">

                                <b-button id="localizar" class="ml-1" size="sm" style="height: 20px" pill
                                    variant="primary" @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                                </b-button>

                                <b-button id="limpar" class="mr-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="clearForm">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                                </b-button>


                            </b-col>
                        </b-form-row>

                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFinderPageSubgrupoProduto id="finderSubgrupo" @onSelect="handleSelectSubgrupo"
                                    v-model="form.subgrupo" :prefix="prefix + title + ' > '" />
                            </b-col>
                            <b-col>
                                <LgFinderPageClasse id="finderClasse" @onselect="handleSelectClasse"
                                    v-model="form.classe" :prefix="prefix + title + ' > '" />
                            </b-col>
                        </b-form-row>

                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFinderPageLocalArmazenamento id="finderLocalArmazenamento1"
                                    @input="handleSelectLocalArmazenamento1" v-model="form.localArmazenamento1"
                                    :prefix="prefix + title + ' > '" label="Local Armazenamento 1:" />
                            </b-col>
                            <b-col>
                                <LgFinderPageTipoMedida id="finderTipoMedida" @input="handleSelectTipoMedida"
                                    v-model="form.tipoMedida" label="Tipo Medida:" :prefix="prefix + title + ' > '" />
                            </b-col>
                        </b-form-row>
                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFinderPageLocalArmazenamento id="finderLocalArmazenamento2"
                                    @input="handleSelectLocalArmazenamento2" :prefix="prefix + title + ' > '"
                                    v-model="form.localArmazenamento2" label="Local Armazenamento 2:" />
                            </b-col>
                            <b-col class="d-flex align-items-center justify-content-start">
                                <b-form-checkbox @change="load" v-model="form.lotePositivo" name="lotePositivo"
                                    :value="true" :unchecked-value="false" class="mr-5">Lote Positivo</b-form-checkbox>
                                <b-form-checkbox @change="load" :disabled="apenasSaldoPositivo"
                                    v-model="form.saldoPositivo" name="saldoPositivo" :value="true"
                                    :unchecked-value="false">Saldo Positivo</b-form-checkbox>
                            </b-col>
                        </b-form-row>
                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFinderPageNatureza id="finderPageNatureza" @input="handleSelectNatureza"
                                    v-model="form.natureza" label="Natureza da Despesa:" cols="12"
                                    :prefix="[prefix + title]" />
                            </b-col>

                            <b-col class="d-flex align-items-center justify-content-start">
                                <b-form-checkbox v-model="form.ordenarRelatorio" name="saldoPositivo" :value="true"
                                    :unchecked-value="false">Ordenar relatório por local de
                                    armazenamento</b-form-checkbox>
                            </b-col>
                        </b-form-row>

                        <b-form-row @keyup.enter="load">
                            <b-col>
                                <LgFormConstSelect label="Disponibilidade:" @change="load"
                                    v-model="form.disponibilidade" :options="[
                                        { value: null, text: 'Todos' },
                                        { value: 0, text: 'Disponível' },
                                        { value: 1, text: 'Bloqueado' },
                                    ]"></LgFormConstSelect>
                            </b-col>
                            <b-col>
                                <LgFormConstSelect @change="load" label="Visibilidade:" v-model="form.visibilidade"
                                    :options="[
                                        { value: null, text: 'Todos' },
                                        { value: 0, text: 'Visível' },
                                        { value: 1, text: 'Invisível' },
                                    ]"></LgFormConstSelect>
                            </b-col>
                        </b-form-row>
                        <b-table responsive class="mt-3" small :busy="this.busy" :items="safeRecords"
                            :fields="Consumofields" hover show-empty>
                            <template #cell(expand)="row">
                                <b-button @click="row.toggleDetails" variant="primary" size="sm"
                                    class="align-items-center justify-content-center d-flex">{{ row.detailsShowing ? "-"
                                        : "+"
                                    }}

                                </b-button>
                            </template>

                            <template #row-details="row">
                                <div v-for="(item, index) in row.item.data" :key="index" style="
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    padding-right: 16px;" class="subrowWrapper" @dblclick="selectItem(item)">
                                    <div style="
                      width: 100%;
                      display: flex;
                      align-items: center;
                      padding-left: 16px;
                      justify-content: space-between;
                    " class="subrow">
                                        <div style="width: 56%; display: flex; gap: 8px">
                                            <b-button @click="handleToggleExpandSubrow(item)" variant="primary"
                                                size="sm" class="align-items-center justify-content-center d-flex">{{
                                                    expandSubrow[item.idProduto] ? "-" : "+"
                                                }}
                                            </b-button>
                                            {{ item.descricaoProduto }}
                                        </div>
                                        <div style="display: flex; gap: 8px; width: 44%">
                                            <div style="width: 62%">{{ item.numeroProduto }}</div>
                                            <div style="width: calc(38% - 27px)">
                                                {{ item.saldo }}
                                            </div>
                                            <div style="width: 27px">
                                                <b-button id="visualizar-ponto-tooltip"
                                                    @click="showModalRessuprimentoFunction(item)" variant="primary"
                                                    size="sm" class="align-items-center justify-content-center">
                                                    <b-icon icon="file-text" />
                                                    <b-tooltip target="visualizar-ponto-tooltip"
                                                        title="Visualizar Ponto Ressuprimento"></b-tooltip>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="expandSubrow[item.idProduto]" style="
                      display: flex;
                      gap: 8px;
                      padding-left: 32px;
                      justify-content: space-between;
                    " class="subrow">
                                        <div style="width: 83%">{{ item.lote }}</div>
                                        <div style="width: calc(17% - 27px); ">
                                            {{ item.saldo }}
                                        </div>
                                        <div style="width: 27px">
                                            <b-button id="visualizar-itens-tooltip" @click="
                                                showModalAlmoxarifadoItemBemConsumoFunction(item)
                                                " variant="primary" size="sm"
                                                class="align-items-center justify-content-center">
                                                <b-icon icon="list-ul" />
                                                <b-tooltip target="visualizar-itens-tooltip"
                                                    title="Visualizar Itens"></b-tooltip>

                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>
                        </b-table>
                        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{
                                    page }} de {{
                                        totalPage }} -
                                    {{ total }} registros</b-col>
                                <b-col cols="6"
                                    style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                        :options="perPageOptions">
                                    </b-form-select>
                                </b-col>
                            </b-col>
                            <b-col cols="6">
                                <div class="d-flex justify-content-end align-items-end">
                                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                        :per-page="perPage" :total-rows="total"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                    <ModalPontoRessuprimentoProduto v-if="showModalRessuprimento" :produto="produto"
                        @close="closeModalPontoRessuprimento" />
                    <ModalAlmoxarifadoItemBemConsumo :prefix="prefix + title + ' > '"
                        v-if="showModalAlmoxarifadoItemBemConsumo" :produto="produto"
                        @close="showModalAlmoxarifadoItemBemConsumo = false" />
                </b-card-body>
            </b-tab>
            <b-tab title="Bens Permanentes">
                <BensPermanentesTab />
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPageSubgrupoProduto from "@/components/Finders/LgFinderPageSubgrupoProduto.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import LgFinderPageClasse from "@/components/Finders/LgFinderPageClasse.vue"
import LgFinderPageTipoMedida from "@/components/Finders/LgFinderPageTipoMedida.vue"
import LgFinderPageNatureza from "@/components/Finders/LgFinderPageNatureza.vue"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import BensPermanentesTab from "./BensPermanentesTab.vue"
import ModalPontoRessuprimentoProduto from "@/components/Modal/ModalPontoRessuprimentoProduto.vue"
import ModalAlmoxarifadoItemBemConsumo from "@/components/Modal/ModalAlmoxarifadoItemBemConsumo.vue"


export default {
    components: {
        LgFinderPageProduto,
        LgFinderPageClasse,
        LgFinderPageAlmoxarifado,
        LgFinderPageSubgrupoProduto,
        LgFinderPageLocalArmazenamento,
        LgFinderPageTipoMedida,
        LgFinderPageNatureza,
        LgFormConstSelect,
        BensPermanentesTab,
        ModalPontoRessuprimentoProduto,
        ModalAlmoxarifadoItemBemConsumo,
    },
    props: {
        apenasSaldoPositivo: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Itens do Almoxarifado",
        },
    },
    mixins: [ListResourceMixin, FormResourceMixin],

    data() {
        return {
            busy: false,
            records: [],
            perPage: 10,
            perPageOptions: [10, 20, 50, 100],
            form: {
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                localArmazenamento1: {},
                tipoMedida: {},
                localArmazenamento2: {},
                lotePositivo: false,
                saldoPositivo: this.apenasSaldoPositivo,
                natureza: {},
                ordenarRelatorio: false,
                disponibilidade: 0,
                visibilidade: null,
            },
            produto: {},
            showModalAlmoxarifadoItemBemConsumo: false,
            showModalRessuprimento: false,
            expandSubrow: {},
        }
    },

    beforeMount() {
        this.$service = new ResourceService("/api/saldo-almoxarifado-produto")

    },

    mounted() {
        this.load()
        this.records.forEach(almoxarifado => {
            almoxarifado.data.forEach(produto => {
                this.$set(produto, "_showDetails", true)
            })
        })
    },

    watch: {
        page() {
            this.load()
        },
    },

    methods: {
        async load() {
            let filtro = {}

            filtro.buscarUsuarioLogado = false;

            if (this.form.almoxarifado.id) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }
            if (this.form.produto.id) {
                filtro.produtoId = this.form.produto.id
            }
            if (this.form.subgrupo.id) {
                filtro.subgrupoId = this.form.subgrupo.id
            }
            if (this.form.classe.id) {
                filtro.classeId = this.form.classe.id
            }
            if (this.form.localArmazenamento1.id) {
                filtro.localArmazenamento1Id = this.form.localArmazenamento1.id
            }
            if (this.form.tipoMedida.id) {
                filtro.tipoMedidaId = this.form.tipoMedida.id
            }
            if (this.form.localArmazenamento2.id) {
                filtro.localArmazenamento2Id = this.form.localArmazenamento2.id
            }
            if (this.form.natureza.id) {
                filtro.naturezaId = this.form.natureza.id
            }
            if (this.form.lotePositivo) {
                filtro.lotePositivo = this.form.lotePositivo
            }
            if (this.form.saldoPositivo) {
                filtro.saldoPositivo = this.form.saldoPositivo
            }
            if (this.form.visibilidade != null) {
                filtro.visibilidade = this.form.visibilidade
            }
            if (this.form.disponibilidade != null) {
                filtro.disponibilidade = this.form.disponibilidade
            }

            this.busy = true

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            })
                .then(response => {
                    const almoxarifado = response.content
                        .map(item => {
                            return {
                                almoxarifado: item.almoxarifado,
                                data: [item],
                            }
                        })
                        .reduce((acc, cur) => {
                            const found = acc.find(
                                item => item.almoxarifado === cur.almoxarifado
                            )
                            if (found) {
                                found.data.push(cur.data[0])
                            } else {
                                acc.push(cur)
                            }
                            return acc
                        }, [])


                    almoxarifado.forEach(item => {
                        item.data.forEach(produto => {
                            this.expandSubrow = {
                                ...this.expandSubrow,
                                [produto.idProduto]: true,
                            }
                        })
                    });
                    this.records = almoxarifado
                    this.total = response.totalElements
                })
                .finally(() => {
                    this.busy = false
                })
        },

        handleSelectAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
            this.load();
        },

        handleSelectProduto(produto) {
            this.form.produto = produto
            this.load();
        },

        handleSelectSubgrupo(subgrupo) {
            this.form.subgrupo = subgrupo
            this.load();
        },

        handleSelectClasse(classe) {
            this.form.classe = classe
            this.load();
        },

        handleSelectLocalArmazenamento1(localArmazenamento1) {
            this.form.localArmazenamento1 = localArmazenamento1
            this.load();
        },

        handleSelectTipoMedida(tipoMedida) {
            this.form.tipoMedida = tipoMedida
            this.load();
        },

        handleSelectLocalArmazenamento2(localArmazenamento2) {
            this.form.localArmazenamento2 = localArmazenamento2
            this.load();
        },

        handleSelectNatureza(natureza) {
            this.form.natureza = natureza
            this.load();
        },

        clearForm() {
            this.form = {
                almoxarifado: {},
                produto: {},
                subgrupo: {},
                classe: {},
                localArmazenamento1: {},
                tipoMedida: {},
                localArmazenamento2: {},
                lotePositivo: false,
                saldoPositivo: this.apenasSaldoPositivo,
                natureza: {},
                ordenarRelatorio: false,
                disponibilidade: 0,
                visibilidade: null,
            }
            this.load();
        },

        toggleProductDetails(produto) {
            if (produto._showDetails === undefined) {
                this.$set(produto, "_showDetails", true)
            } else {
                produto._showDetails = !produto._showDetails
            }
        },

        closeModalPontoRessuprimento() {
            this.produto = {};
            this.showModalRessuprimento = false;
        },

        selectItem(item) {
            this.$emit("onSelectItem", item);
        },

        showModalRessuprimentoFunction(produto) {
            this.produto = produto
            this.showModalRessuprimento = true
        },
        showModalAlmoxarifadoItemBemConsumoFunction(produto) {
            this.produto = produto
            this.showModalAlmoxarifadoItemBemConsumo = true
        },

        handleToggleExpandSubrow(produto) {
            this.expandSubrow = {
                ...this.expandSubrow,
                [produto.idProduto]: !this.expandSubrow[produto.idProduto],
            }
        },
    },

    computed: {
        Consumofields() {
            return [
                { key: "expand", label: "", thClass: "w-1", tdClass: "w-1" },
                {
                    key: "almoxarifado",
                    _showDetails: true,
                    label: "Descrição",
                    tdStyle: { width: "50%" },
                    thStyle: { width: "50%" },
                },
                {
                    key: "numeroProduto",
                    label: "Número",
                },
                {
                    key: "saldo",
                    label: "Saldo",
                    tdStyle: { width: "20%" },
                    thStyle: { width: "20%" },
                },
            ]
        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },

        safeRecords() {
            return this.records || []
        },
    },
}
</script>
<style>
.hidden_header {
    display: none;
}

.b-table-details {
    background-color: #fff !important;
}

.subrow:hover {
    background-color: rgba(0, 0, 0, 0.075);
}

.subrowWrapper:not(:last-child) {
    margin-bottom: 8px;
}
</style>
